import { module } from 'modujs';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-esm/ScrollTrigger';
import { getViewport } from '../utils/utilities';
gsap.registerPlugin(ScrollTrigger);

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.fx();
  }

  fx() {
    this.animation = gsap.timeline({
      scrollTrigger: {
        trigger: this.DOM.view,
        start: 'top top',
        pin: true,
        pinSpacing: false,
        scrub: 0.9,
        end: () => {
          const viewport = getViewport();
          return `+=${viewport.height}px`;
        },
        invalidateOnRefresh: true,
      },
    });

    this.animation.add([
      gsap.fromTo(
        this.DOM.view.querySelectorAll('.css-bg'),
        {
          scale: 1,
        },
        {
          scale: 1.1,
        }
      ),
    ]);
  }

  destroy() {
    gsap.killTweensOf(this.animation);
  }
}
